import { ORGANIZATIONS_PREFIX } from "@cti-workspace/helpers";
import getPaginationAndSearch from "./paginationAndSearch";

const GetOrganizations = (pageSize = null, pageNumber = null, search = null, returnItems = true) => {
	return getPaginationAndSearch(`/${ORGANIZATIONS_PREFIX}/getAll`, pageSize, pageNumber, search, returnItems);
};

export default GetOrganizations;
